<template>
    <div
        v-if="paymentMethod"
        class="relative bg-white border border-white flex flex-row items-center gap-4 p-2 rounded-md shadow-md cursor-pointer"
        :class="[paymentMethod.primary === true ? 'border-blue' : '', isExpired ? 'shadow-red' : '']"
    >
        <div v-if="showToggle" class="flex items-center justify-center cursor-pointer ml-2">
            <div class="w-4 h-4 rounded-full border border-blue" :class="active ? 'bg-blue' : ''" />
        </div>

        <div class="p-2 w-full" v-if="paymentMethod.method === 'CREDITCARD'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-wrap gap-2 text-black items-center">
                <img
                    :alt="paymentMethod.meta.display_text"
                    class="h-6"
                    :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')"
                />
                <div class="text-xxs flex-1 flex-wrap-holder">
                    <span>
                        <p>
                            {{ paymentMethod.meta.display_text }} &nbsp;
                            <span :class="isExpired ? 'text-red' : ''">{{ paymentMethod.meta.expires ? '(' + paymentMethod.meta.expires + ')' : '' }}</span>
                        </p>
                        <p>{{ paymentMethod.meta.holder_name }}</p>
                    </span>
                </div>
            </div>
        </div>
        <div class="p-2 w-full" v-if="paymentMethod.method === 'DIRECTDEBIT'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-row gap-2 text-black items-center">
                <img
                    :alt="paymentMethod.meta.display_text"
                    class="h-6"
                    :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')"
                />
                <span class="text-xxs">
                    <span v-if="paymentMethod?.meta?.display_text">{{ paymentMethod.meta.display_text }}</span>
                    <span v-else>{{ getNameFromPaymentMethod(paymentMethod) }}</span>
                </span>
            </div>
        </div>
        <div class="p-2 w-full" v-if="paymentMethod.method === 'REFERENCE_TRANSACTIONS'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-row gap-2 text-black items-center">
                <img alt="paypal" class="h-6" :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')" />
                <span class="text-xxs">
                    <span v-if="paymentMethod?.meta?.email">{{ paymentMethod.meta.email }}</span>
                    <span v-else>{{ getNameFromPaymentMethod(paymentMethod) }} </span>
                </span>
            </div>
        </div>

        <div class="p-2 w-full" v-if="paymentMethod.method === 'PAYPAL'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-row gap-2 text-black items-center">
                <img alt="paypal" class="h-6" :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')" />
                <span class="text-xxs">
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </span>
            </div>
        </div>

        <div class="p-2 w-full" v-if="paymentMethod.method === 'APPLEPAY'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-row gap-2 text-black items-center">
                <img alt="paypal" class="h-6" :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')" />
                <div class="text-xxs flex-1 flex-wrap-holder">
                    <span>
                        <p>{{ paymentMethod.meta.brand_name }}</p>
                        <p>
                            {{ paymentMethod.meta.display_text }} &nbsp;
                            <span :class="isExpired ? 'text-red' : ''">{{ paymentMethod.meta.expires ? '(' + paymentMethod.meta.expires + ')' : '' }}</span>
                        </p>
                    </span>
                </div>
            </div>
        </div>

        <div class="p-2 w-full" v-if="paymentMethod.method === 'GOOGLEPAY'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-row gap-2 text-black items-center">
                <img alt="paypal" class="h-6" :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')" />
                <div class="text-xxs flex-1 flex-wrap-holder">
                    <span>
                        <p>{{ paymentMethod.meta.brand_name }}</p>
                        <p>
                            {{ paymentMethod.meta.display_text }} &nbsp;
                            <span :class="isExpired ? 'text-red' : ''">{{ paymentMethod.meta.expires ? '(' + paymentMethod.meta.expires + ')' : '' }}</span>
                        </p>
                    </span>
                </div>
            </div>
        </div>

        <div class="p-2 w-full" v-if="paymentMethod.method === 'MASTERCARD'">
            <div>
                <small>
                    {{ getNameFromPaymentMethod(paymentMethod) }}
                </small>
            </div>
            <div class="flex flex-wrap gap-2 text-black items-center">
                <img
                    :alt="paymentMethod.meta.display_text"
                    class="h-6"
                    :src="$asset('/hkcm/images/payment-methods/' + getImageFromPaymentMethod(paymentMethod) + '.svg', 'public')"
                />
                <div class="text-xxs flex-1 flex-wrap-holder">
                    <span>
                        <p>
                            {{ paymentMethod.meta.display_text }} &nbsp;
                            <span :class="isExpired ? 'text-red' : ''">{{ paymentMethod.meta.expires ? '(' + paymentMethod.meta.expires + ')' : '' }}</span>
                        </p>
                        <p>{{ paymentMethod.meta.holder_name }}</p>
                    </span>
                </div>
            </div>
        </div>
        <slot name="options"></slot>

        <div v-if="paymentMethod.primary" class="absolute top-0 right-0 mt-2 mr-2 bg-blue-500 text-white text-xs px-2 py-1 rounded-full">
            {{ $t('default') }}
        </div>
    </div>
</template>

<script>
import { getNameFromPaymentMethod, getImageFromPaymentMethod, convertToLastDay } from '../../helpers.js';

export default {
    props: {
        paymentMethod: Object,
        active: Boolean,
        showToggle: Boolean
    },
    data() {
        return {
            isExpired: false
        };
    },
    mounted() {
        this.checkIfExpired(this.paymentMethod);
    },
    methods: {
        getImageFromPaymentMethod,
        getNameFromPaymentMethod,
        checkIfExpired(paymentMethod) {
            if (!paymentMethod?.meta?.expires) {
                return false;
            }

            const expiryDate = convertToLastDay(paymentMethod.meta.expires);

            this.isExpired = expiryDate < new Date();

            return this.isExpired;
        }
    }
};
</script>

<style scoped>
.bg-blue-500 {
    background-color: #3b82f6;
}
.text-white {
    color: #ffffff;
}
.rounded-full {
    border-radius: 9999px;
}
.absolute {
    position: absolute;
}
.top-0 {
    top: 0;
}
.right-0 {
    right: 0;
}
.mt-2 {
    margin-top: 0.5rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.flex {
    display: flex;
}
.flex-wrap {
    flex-wrap: wrap;
}
.gap-2 {
    gap: 0.5rem;
}
.text-xxs {
    font-size: 0.75rem;
}
.flex-1 {
    flex: 1;
}
.flex-wrap-holder {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
}
.ml-2 {
    margin-left: 0.5rem;
}
</style>
